"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayOfStrings = isArrayOfStrings;

function isArrayOfStrings(array) {
  return Array.isArray(array) && array.every(function (item) {
    return typeof item === 'string';
  });
}